export const tariffKeys = {
  tariff: ['tariff'],
  tariffs: ['tariffs'],
  projectTariff: (slug: string) => [...tariffKeys.tariff, slug],
};
